module.exports = __webpack_public_path__ + "img/deploy-app-2.b36aa9ef.png";